import { Component } from '@angular/core';
import { FieldWrapper, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { humanizeFieldKey } from './formly.config';

export interface DataHubWrapperProps extends FormlyFieldProps {
	format?: string;
	example?: any;
}

@Component({
	selector: 'formly-nebular-form-field',
	template: `
		<div [class.required]="props.required" class="form-group col-md-4">
			<label>
				{{ props.label || humanizeFieldKey(field.key) }}
				@if (props.format) {
					<small>({{ props.format }})</small>
				}
			</label>
			<ng-container #fieldComponent></ng-container>
			@if (props.example !== undefined) {
				<small class="form-text text-muted"><b>Example:</b> {{ props.example }}</small>
			}
			@if (props.description) {
				<small class="form-text text-muted">{{ props.description }}</small>
			}
		</div>
	`
})
export class FormlyNebularFormFieldWrapperComponent extends FieldWrapper<FieldTypeConfig<DataHubWrapperProps>> {
	protected humanizeFieldKey = humanizeFieldKey;
}
